import Platformer1 from "./1.jpg";
import Platformer2 from "./2.jpg";
import Platformer3 from "./3.jpg";
import Platformer4 from "./4.jpg";
import Platformer5 from "./5.jpg";
import Platformer6 from "./6.jpg";
import Platformer7 from "./7.jpg";

const Platformer: Array<typeof module> = [
    Platformer1,
    Platformer2,
    Platformer3,
    Platformer4,
    Platformer5,
    Platformer6,
    Platformer7,
];

export { Platformer };
